import React from "react";
import GridViewIcon from "@mui/icons-material/GridView";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

function ProjectsIconButton({ onClick, disabled }) {
  const { t } = useTranslation();
  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: "#305d82",
        borderRadius: "4px",
        // display: "flex",
        // justifyContent: "center",
        width: "20%",
        height: "136px",
        padding: "15px 0px",
        textAlign: "center",
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
        "&:hover": {
          backgroundColor: "#5c92cd",
        },
      }}
    >
      <GridViewIcon
        sx={{
          color: "#FFFFFF",
          fontSize: 64,
        }}
      />
      <Typography
        sx={{
          fontSize: { xs: "1rem", sm: "1rem" },
          color: "#FFFFFF",
        }}
        variant="h4"
        gutterBottom
      >
        {t("ProjectsComingSoon")}
      </Typography>
    </Box>
  );
}
ProjectsIconButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default ProjectsIconButton;
